import { render, staticRenderFns } from "./WidgetNightsPerSite.vue?vue&type=template&id=06fda5c2&scoped=true"
import script from "./WidgetNightsPerSite.vue?vue&type=script&lang=js"
export * from "./WidgetNightsPerSite.vue?vue&type=script&lang=js"
import style0 from "./WidgetNightsPerSite.vue?vue&type=style&index=0&id=06fda5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fda5c2",
  null
  
)

export default component.exports